import Layout from '@/View/HRM/layout/layout.vue'

export const HRM = { // dashboard object start
  path: '/hrm',
  component: Layout,
  hidden: false,
  redirect: '/hrm/dashboard',
  name: 'HRM',
  meta: {
    breadCrumb: 'Dashboard',
    title: 'dashboards',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [{
    path: '/hrm/dashboard',
    component: () => import('@/View/HRM/dashboard/dashboard.vue'),
    name: 'HRMDashboard',
    meta: {
      breadCrumb: 'HRMDashboard',
      icon: 'dashboard',
      title: 'Dashboard',
      permissionList: ['abc', 'def']
    }
  },
  {// Employee object start
    path: '/hrm/employee',
    component: () => import('@/View/HRM/Main/index.vue'),
    hidden: false,
    redirect: {name: 'EmployeeList'},
    name: 'HEmployee',
    meta: {
      breadCrumb: 'Employee',
      title: 'Employee',
      icon: 'fa fa-user',
      selected: false,
      permission: ['isViewAll', 'isViewRelated']
    },
    children: [{
      path: 'list',
      component: () => import('@/View/HRM/Employee/EmployeeList.vue'),
      name: 'EmployeeList',
      meta: {
        breadCrumb: 'EmployeeList',
        icon: 'fa fa-user',
        title: 'List',
        permissionList: []
      }
    },
    {
      path: 'add',
      component: () => import('@/View/HRM/Employee/NewEmployee.vue'),
      name: 'Employee',
      meta: {
        breadCrumb: 'New Employee',
        icon: 'fa fa-user',
        title: 'Add',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'details/:employeeId',
      component: () => import('@/View/HRM/Employee/EmployeeDetail.vue'),
      name: 'EmployeeDetail',
      meta: {
        breadCrumb: 'Employee Details',
        icon: 'fa fa-user',
        title: 'Details',
        permissionList: ['abc', 'def']

      }
    }]
  },
  // {
  //   // All Shift object start
  //   path: '/hrm/timesheet',
  //   component: () => import('@/View/HRM/Main/index.vue'),
  //   hidden: false,
  //   redirect: {name: 'Timesheet'},
  //   name: 'HTimesheet',
  //   meta: {
  //     breadCrumb: 'Timesheet',
  //     title: 'Timesheet',
  //     icon: 'fas fa-clock',
  //     selected: false,
  //     permission: ['isViewAll', 'isViewRelated']
  //   },
  //   children: [{
  //     path: 'list',
  //     component: () => import('@/View/HRM/timesheet/timeSheetList.vue'),
  //     name: 'Timesheet',
  //     meta: {
  //       icon: 'mdi mdi-timelapse',
  //       title: 'Timesheet',
  //       permissionList: ['abc', 'def']
  //     },
  //     children: [
  //       {
  //         path: '/hrm/timesheet/currentshift',
  //         component: () => import('@/View/HRM/timesheet/TodaysShift/openShift.vue'),
  //         name: 'CurrentShiftList',
  //         meta: {
  //           breadcrumb: 'currentshift',
  //           icon: 'mdi mdi-timelapse',
  //           title: 'Current Shift',
  //           permissionList: ['abc', 'def']
  //         }
  //       },
  //       {
  //         path: '/hrm/timesheet/allshift',
  //         component: () => import('@/View/HRM/timesheet/AllShiftList/allShift.vue'),
  //         name: 'AllShiftList',
  //         meta: {
  //           breadcrumb: 'AllShift',
  //           icon: 'mdi mdi-timelapse',
  //           title: 'All Shift',
  //           permissionList: ['abc', 'def']
  //         }
  //       },
  //       {
  //         path: '/hrm/timesheet/completedshift',
  //         component: () => import('@/View/HRM/timesheet/TodaysShift/completedShift.vue'),
  //         name: 'CompletedShift',
  //         meta: {
  //           breadcrumb: 'completedshift',
  //           icon: 'mdi mdi-timelapse',
  //           title: 'Completed Shift',
  //           permissionList: ['abc', 'def']
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     path: 'details/:timesheetId',
  //     component: () => import('@/View/HRM/timesheet/timesheetDetail.vue'),
  //     name: 'TimesheetDetails',
  //     meta: {
  //       breadCrumb: 'Timesheet Details',
  //       icon: 'mdi mdi-timelapse',
  //       title: 'Details',
  //       permissionList: ['abc', 'def']
  //     }
  //   },
  //   {
  //     path: '/my/timesheet/details/:timesheetId/:redirectFromMenu',
  //     component: () => import('@/View/HRM/timesheet/timesheetDetail.vue'),
  //     name: 'MyTimeSheetDetails',
  //     meta: {
  //       breadCrumb: 'Timesheet Details',
  //       icon: 'mdi mdi-timelapse',
  //       title: 'My Timesheet Details',
  //       permissionList: ['abc', 'def']
  //     }
  //   }]
  // },
  // {
  //   // All Shift object start
  //   path: '/hrm/missingshift',
  //   component: () => import('@/View/HRM/Main/index.vue'),
  //   hidden: false,
  //   redirect: {name: 'MissingShift'},
  //   name: 'HMissingShift',
  //   meta: {
  //     breadCrumb: 'Missing Shift',
  //     title: 'Missing Shift',
  //     icon: 'mdi mdi-timelapse',
  //     selected: false,
  //     permission: ''
  //   },
  //   children: [{
  //     path: 'MissingShift',
  //     component: () => import('@/View/HRM/timesheet/MissingShift/missingShift.vue'),
  //     name: 'MissingShift',
  //     meta: {
  //       icon: 'mdi mdi-timelapse',
  //       title: 'Missing Shift',
  //       permissionList: ['abc', 'def']
  //     }
  //   }
  //   ]
  // },
  {// Leave object start
    path: '/hrm/leave',
    component: () => import('@/View/HRM/Main/index.vue'),
    hidden: false,
    redirect: {name: 'LeaveList'},
    name: 'HLeaveList',
    meta: {
      breadCrumb: 'Leave',
      title: 'Leave',
      icon: 'fas fa-plane',
      selected: false,
      permission: ['isViewAll', 'isViewRelated']
    },
    children: [{
      path: 'list',
      component: () => import('@/View/HRM/LeaveManagement/leaveList.vue'),
      name: 'LeaveList',
      meta: {
        icon: 'fas fa-bus',
        title: 'List',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'details/:leaveId',
      component: () => import('@/View/HRM/LeaveManagement/leaveDetails.vue'),
      name: 'LeaveDetails',
      meta: {
        breadCrumb: 'Leave Details',
        icon: 'fa fa-clock',
        title: 'Details',
        permissionList: ['abc', 'def']
      }
    }]
  },
  {// Holiday object start
    path: '/hrm/holiday',
    component: () => import('@/View/HRM/Main/index.vue'),
    hidden: false,
    redirect: {name: 'HolidayList'},
    name: 'HHolidayList',
    meta: {
      breadCrumb: 'Holiday',
      title: 'Holiday',
      icon: 'fas fa-calendar-alt',
      selected: false,
      permission: ['isViewAll', 'isViewRelated']
    },
    children: [{
      path: 'list',
      component: () => import('@/View/HRM/Holiday/holidayListView.vue'),
      name: 'HolidayList',
      meta: {
        icon: 'fas fa-bus',
        title: 'List',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'details/:holidayListId',
      component: () => import('@/View/HRM/Holiday/holidayDetails.vue'),
      name: 'HolidayDetails',
      meta: {
        breadCrumb: 'Holiday Details',
        icon: 'fa fa-clock',
        title: 'Details',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'add',
      component: () => import('@/View/HRM/Holiday/AddNewHolidayList/addNewHolidayList.vue'),
      name: 'AddNewHoliday',
      meta: {
        breadCrumb: 'New Holiday',
        icon: 'fa fa-clock',
        title: 'Add',
        permissionList: ['abc', 'def']
      }
    }]
  },
  {// Setting object start
    path: '/hrm/setting',
    component: () => import('@/View/HRM/Main/index.vue'),
    hidden: false,
    redirect: '/hrm/setting/dashboard',
    name: 'Setting',
    meta: {
      breadCrumb: 'Setting',
      title: 'Settings',
      icon: 'fa fa-cog',
      selected: true,
      permissionSlug: 'Setting',
      permissionList: ['']
    },
    children: [{
      path: 'dashboard',
      component: () => import('@/View/HRM/Setting/setting.vue'),
      name: 'SettingDashboard',
      hidden: true,
      meta: {
        icon: 'fa fa-cog',
        title: 'Dashboard',
        selected: false,
        permissionList: ['']
      }
    },
    {
      path: 'branch/list',
      component: () => import('@/View/HRM/Setting/Branch/branch.vue'),
      name: 'Branch',
      hidden: false,
      icon: 'mdi-home-city',
      meta: {
        breadCrumb: 'Branch',
        title: 'Branch',
        color: '#26c6da',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'branch'
      }
    },
    {
      path: 'branch/details/:branchId',
      component: () => import('@/View/HRM/Setting/Branch/BranchDetails.vue'),
      name: 'BranchDetails',
      hidden: true,
      icon: '',
      meta: {
        breadCrumb: 'Branch Detail',
        title: 'Branch Detail',
        permissionList: [''],
        permissionSlug: 'department'
      }
    },
    {
      path: 'department',
      component: () => import('@/View/HRM/Setting/Department/DepartmentList.vue'),
      name: 'DepartmentList',
      icon: 'mdi-desktop-classic',
      hidden: false,
      meta: {
        breadCrumb: 'Department',
        title: 'Department',
        color: '#07575B',
        permissionList: ['isViewAll'],
        permissionSlug: 'department'
      }
    },
    {
      path: 'device',
      component: () => import('@/View/HRM/Setting/Device/deviceList.vue'),
      name: 'DeviceList',
      icon: 'fa fa-laptop',
      hidden: false,
      meta: {
        breadCrumb: 'Device',
        title: 'Device',
        color: '#f52549',
        permissionList: ['isViewAll'],
        permissionSlug: 'device'
      }
    },
    // {
    //   path: 'break',
    //   component: () => import('@/View/HRM/Setting/Break/BreakList.vue'),
    //   name: 'BreakList',
    //   icon: 'mdi-clock',
    //   hidden: false,
    //   meta: {
    //     breadCrumb: 'Break',
    //     title: 'Break',
    //     color: 'purple',
    //     permissionList: ['isViewAll'],
    //     permissionSlug: 'break'
    //   }
    // },
    {
      path: 'designation',
      component: () => import('@/View/HRM/Setting/Designation/Designation.vue'),
      name: 'Designation',
      icon: 'mdi-account-star',
      hidden: false,
      meta: {
        breadCrumb: 'Designation',
        title: 'Designation',
        color: '#F78B2D',
        permissionList: ['isViewAll'],
        permissionSlug: 'designation'
      }
    },
    {
      path: 'employee/type',
      component: () => import('@/View/HRM/Setting/EmployeeType/EmployeeType.vue'),
      name: 'EmployeeType',
      icon: 'mdi-account-tie',
      hidden: false,
      meta: {
        breadCrumb: 'EmployeeType',
        title: 'Employee Type',
        color: '#1e88e5',
        permissionList: ['isViewAll'],
        permissionSlug: 'type'
      }
    },
    {
      path: 'shift',
      component: () => import('@/View/HRM/Setting/Shift/Shift.vue'),
      name: 'Shift',
      icon: 'fas fa-user-clock',
      hidden: false,
      meta: {
        breadCrumb: 'Shift',
        color: '#4caf50',
        title: 'Shift',
        permissionList: ['isViewAll'],
        permissionSlug: 'shift'
      }
    },
    {
      path: 'leave/reason',
      component: () => import('@/View/HRM/Setting/LeaveReason/leaveReasonList.vue'),
      name: 'LeaveReason',
      icon: 'mdi-account-question',
      hidden: false,
      meta: {
        breadCrumb: 'Leave Reason',
        title: 'LeaveReason',
        color: '#F52549',
        permissionList: ['isViewAll'],
        permissionSlug: 'leavereason'
      }
    },
    {
      path: 'leave/status',
      component: () => import('@/View/HRM/Setting/LeaveStatus/leaveStatus.vue'),
      name: 'LeaveStatus',
      icon: 'mdi-comment-question',
      hidden: false,
      meta: {
        breadCrumb: 'Leave Status',
        title: 'LeaveStatus',
        color: '#feb019',
        permissionList: ['isViewAll'],
        permissionSlug: 'leavestatus'
      }
    },
    // {
    //   path: '/Setting/Holidays/Holidays',
    //   component: () => import('@/View/HRM/Setting/Holidays/Holidays12MonthView.vue'),
    //   name: 'Holidays',
    //   icon: 'fas fa-calendar-check',
    //   hidden: false,
    //   meta: {
    //     breadCrumb: 'Holidays',
    //     title: 'Holidays',
    //     color: 'indigo accent-1',
    //     permissionList: ['isViewAll'],
    //     permissionSlug: 'category',
    //   }
    // },
    {
      path: 'role',
      component: () => import('@/View/HRM/Setting/Role/roleList.vue'),
      name: 'Role',
      icon: 'fab fa-black-tie',
      hidden: false,
      meta: {
        breadCrumb: 'Role',
        title: 'Role',
        color: '#66A5A8',
        permissionList: ['isViewAll'],
        permissionSlug: 'role'
      }
    },
    {
      path: 'employeeinshift/:shiftId',
      component: () => import('@/View/HRM/Setting/Shift/employeeInShift.vue'),
      name: 'EmployeesInShift',
      icon: 'fa fa-cog',
      hidden: true,
      meta: {
        breadCrumb: 'Employee(s) In Shift',
        title: 'Employee(s) In Shift',
        color: '#2196f3',
        permissionList: [''],
        permissionSlug: ''
      }
    },
    {
      path: 'department/branch/:branchId',
      component: () => import('@/View/HRM/Setting/Branch/departmentAndEmployee.vue'),
      name: 'DepartmentInBranch',
      icon: 'fa fa-cog',
      hidden: true,
      meta: {
        breadCrumb: 'Branch',
        title: 'Branch',
        color: '#2196f3',
        permissionList: [''],
        permissionSlug: ''
      }
    },
    {
      path: 'change/department/details/:departmentId',
      component: () => import('@/View/HRM/Setting/Department/changeDepartmentDetails.vue'),
      name: 'ChangeDepartmentDetails',
      icon: 'fa fa-cog',
      hidden: true,
      meta: {
        breadCrumb: 'Department',
        title: 'Department',
        color: '#2196f3',
        permissionList: [''],
        permissionSlug: ''
      }
    },
    {
      path: 'holiday/category',
      component: () => import('@/View/HRM/Setting/Category/category.vue'),
      name: 'HolidayCategory',
      hidden: false,
      icon: 'fas fa-filter',
      meta: {
        breadCrumb: 'Holiday Category',
        title: 'Holiday Category',
        color: 'secondary',
        permissionList: ['isViewAll'],
        permissionSlug: 'category'
      }
    }]
  }
  ]
}



// WEBPACK FOOTER //
// ./src/View/HRM/router/index.js